<template>
    <div class="all">
        <van-nav-bar
                title
                left-text="返回"
                left-arrow
                @click-left="$goBack()"
                @click-right
        />

        <img :src="task.h5BannerUrl">

        <div class="explain">
            <van-row>
                <van-col  v-html="task.pcHml">
                </van-col>
            </van-row>

        </div>

        <van-button type="default" size="large" @click="signUp()"   v-if="task.traderId==null">
            <strong>
                立 即 报 名
            </strong>
        </van-button>

        <van-button type="default" size="large" @click="queryCode(task.id)" v-else>
            <strong>
                查 看 二 维 码
            </strong>
        </van-button>
    </div>
</template>

<script>
    import u87 from '@/assets/images/u87.png'
    import mainAPI from '@/api/main'

    export default {
        data() {
            return {
                u87: u87,
                from: {
                    jobId: '',
                    title: '',
                    taskTime: '长期有效',//任务有效期
                    taskPower: '联盟会员',//领取权限
                    activity: {
                        activityTime: '2019年1月10日 00:00:00---2019年3月10日 23:59:59',//活动时间
                        costName: '  针对淘宝客户端玩法在收购CPA费用上分为两个部分：',//费用说明
                        costValue: '',//费用内容
                        Remarks: '活动页面沿用之前的活动页面,活动链接不变',
                        url: 'https://youzan.github.io/vant/#/zh-CN/intro'
                    },
                    methodOne: ' 新用户188礼包,老用户超级红包,用户分享拉新得10元红包',//玩法

                },
                signUpList: {},
                query: {
                    jobId: '',
                },
                task: {},
            }
        },
        created() {
            this.getParams();
        },
        methods: {
            queryCode(id) {
                this.$router.push('/main/task/share?id=' + id);
            },
            getParams() {
                var routerParams = this.$route.query.id
                this.query.jobId = routerParams
                this.mainTask();
            },

            mainTask() {
                mainAPI.taskInfo(this.query.jobId,null,null).then((result) => {
                    this.task = result.data;
                })
            },

            signUp() {
                if (this.query.jobId) {
                    mainAPI.signUp(parseInt(this.query.jobId)).then((result) => {
                        this.$toast.success('领取成功');
                    })
                }

            }
        },
    }
</script>

<style lang="scss" scoped>

    .all {
        background-color: #fff;
        font-size: 1.2rem;
    }

    img {
        width: 100%;
        overflow: hidden;

    }

    .explain {
        margin: 1rem 2rem;
        .van-row {
            margin-top: 0.5rem;
        }
    }

    .van-button {
        margin-top: 10%;
        left: 7%;
        width: 85%;
        background-color: coral;
        color: #fff;
        font-size: 1.2rem;
    }

</style>
